<script lang="ts" setup>
    const props = defineProps<{
        blok: AdventcalendarDayStoryblok;
        isFlipped: boolean;
        locked: boolean;
    }>();

    const emit = defineEmits<{
        (e: 'doorClick'): void;
    }>();

    const { t } = useI18n();

    const flipped = computed(() => props.isFlipped);

    function handleClick() {
        if (props.locked) return;
        emit('doorClick');
    }
</script>

<template>
    <div
        class="card"
        :class="{ locked }"
        @click="handleClick"
    >
        <div
            class="card-inner"
            :class="{ flipped }"
        >
            <div class="front">
                <StoryblokImage
                    :media="blok.background"
                    :type="'memoryCard'"
                    :alt="''"
                />
            </div>

            <div
                v-if="isFlipped"
                class="back"
            >
                <div class="product">
                    <div class="image-container">
                        <StoryblokImage
                            :media="blok.image"
                            :type="'memoryCard'"
                            :alt="blok.image.alt ? blok.image.alt : ''"
                        />
                    </div>
                    <PrimaryButton
                        :button-text="blok.buttonText ?? t('adventCalendar.readMore')"
                        size="small"
                        @click.stop="emit('doorClick')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/pta-family/adventcalendar/adventcalendar-card.scss';
</style>
